import React from 'react';
import SigniantLogoImage from './signiantLogo.svg';
import styled from 'styled-components';
import { Link } from 'gatsby';

//slightly different margines to try and adapt to the different logo shapes
const SigniantLogo = styled.img`
    @media only screen and (max-width: 599px) {
        /* For mobile phones: */
         {
            margin-left: 0;
        }
    }
    padding-top: 0px;
    margin-bottom: 0.3em;
    height: 3.5em;
`;

const getProductAccordion = (props) => {
    return (
        <Link to="/">
            <SigniantLogo src={SigniantLogoImage} alt="signiant-logo" {...props} />
        </Link>
    );
};

const SigniantHeaderLogo = (props) => getProductAccordion(props);

export default SigniantHeaderLogo;
